import { useState, useEffect, useRef } from 'react';
import { parametricosService } from '@/lib/api/parametricosService';

type PlazoOption = { value: string; label: string };

interface PlazosState {
  plazos: PlazoOption[];
  loading: boolean;
}

// Cache global para evitar múltiples llamadas al API
let cachedPlazos: PlazosState | null = null;
let fetchPromise: Promise<PlazosState> | null = null;

async function fetchPlazos(): Promise<PlazosState> {
  if (cachedPlazos) return cachedPlazos;

  if (fetchPromise) return fetchPromise;

  fetchPromise = parametricosService.getPlazosDisponibles()
    .then(resp => {
      console.log('Respuesta plazos API:', resp);
      // Todos los plazos disponibles sin distinción de producto
      const result: PlazosState = {
        plazos: resp.data?.todos || resp.data?.plazos || [],
        loading: false,
      };
      console.log('Plazos cargados:', result);
      cachedPlazos = result;
      return result;
    })
    .catch(err => {
      console.error('Error cargando plazos:', err);
      return {
        plazos: [],
        loading: false,
      };
    })
    .finally(() => {
      fetchPromise = null;
    });

  return fetchPromise;
}

/**
 * Hook para obtener todos los plazos disponibles desde paramétricos.
 * Usa cache global para evitar múltiples llamadas al API.
 * Devuelve todos los plazos sin distinción de tipo de producto.
 */
export function usePlazosDisponibles() {
  const [state, setState] = useState<PlazosState>(() => {
    // Si ya hay cache, usarlo inmediatamente
    if (cachedPlazos) return cachedPlazos;
    return {
      plazos: [],
      loading: true,
    };
  });

  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;

    if (!cachedPlazos) {
      fetchPlazos().then(result => {
        if (mounted.current) {
          setState(result);
        }
      });
    }

    return () => {
      mounted.current = false;
    };
  }, []);

  return state;
}

/**
 * Invalida el cache de plazos (útil después de actualizar paramétricos).
 */
export function invalidatePlazosCache() {
  cachedPlazos = null;
  fetchPromise = null;
}
